import { IframeModeService } from '../services/iframeModeService';

export function navigateTo(url: string) {
  if (IframeModeService.isIframeMode()) {
    IframeModeService.changeLocation(url)
  }
  else {
    window.location.href = url;
  }
}
